export default "__VITE_ASSET__WBc5Jt7v__"